/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FamilyMember } from '../models';
/**
 * AdminFamilyApi - axios parameter creator
 * @export
 */
export const AdminFamilyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
         * @summary get family members
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminFamilyMembers: async (id: number, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdminFamilyMembers', 'id', id)
            const localVarPath = `/admin/family/citizen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFamilyApi - functional programming interface
 * @export
 */
export const AdminFamilyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFamilyApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
         * @summary get family members
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminFamilyMembers(id: number, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FamilyMember>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminFamilyMembers(id, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFamilyApi.getAdminFamilyMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFamilyApi - factory interface
 * @export
 */
export const AdminFamilyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFamilyApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
         * @summary get family members
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminFamilyMembers(id: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FamilyMember>> {
            return localVarFp.getAdminFamilyMembers(id, filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminFamilyApi - interface
 * @export
 * @interface AdminFamilyApi
 */
export interface AdminFamilyApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
     * @summary get family members
     * @param {number} id 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFamilyApiInterface
     */
    getAdminFamilyMembers(id: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FamilyMember>>;

}

/**
 * AdminFamilyApi - object-oriented interface
 * @export
 * @class AdminFamilyApi
 * @extends {BaseAPI}
 */
export class AdminFamilyApi extends BaseAPI implements AdminFamilyApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"FamilyMember\"] 
     * @summary get family members
     * @param {number} id 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFamilyApi
     */
    public getAdminFamilyMembers(id: number, filter?: string, options?: RawAxiosRequestConfig) {
        return AdminFamilyApiFp(this.configuration).getAdminFamilyMembers(id, filter, options).then((request) => request(this.axios, this.basePath));
    }
}

